<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="externalUsers"
  [(selectedItems)]="_selectedExternalUsers"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="43"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="label"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [itemDescriptionField]="showActivePassStatus ? 'activePassStatus' : null"
  optionLabel="profile.name"
  filterBy="profile.name"
  [showClear]="showClear"
  [loading]="loading || selectionLoading">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
